import { useQuery } from '@tanstack/react-query';
import { type FlowRunBlockDataVariant } from 'flow-schema';

import { api, getQueryProps, isTruthy } from 'common';

interface FindLatestTestRunApiProps {
  flowDefinitionId: string | null;
  blockRunDataVariant?: FlowRunBlockDataVariant;
  staleTime?: number;
}

export function useFindLatestTestRunApi(props: FindLatestTestRunApiProps) {
  const { flowDefinitionId, blockRunDataVariant, staleTime } = props;
  const result = useQuery({
    ...getQueryProps(
      api.client.FlowDefinition,
      'findLatestTestRun',
      flowDefinitionId ?? 'INVALID_ID',
      blockRunDataVariant
    ),
    select: (data) => data.latestRun,
    enabled: isTruthy(flowDefinitionId),
    staleTime,
  });

  return result;
}
